module.exports = __webpack_public_path__ + "img/10.61e91116.png";